import React, {useState} from 'react';

import useGroup from 'hooks/useGroup';
import useSession from 'hooks/useSession';
import ModalAddGroup from 'components/Group/ModalAddGroup';

function EditGroup(props) {
	const [openModalAddGroup, setOpenModalAddGroup] = useState(false);

	const {
		group
	} = useGroup();

	const {
		defaultGroup
	} = useSession();

	if (group && group.id && group.id === defaultGroup.id) {
		return (null);
	}

	return (
		<>
			<ModalAddGroup
				forceOpen={openModalAddGroup}
				setForceOpenOpen={setOpenModalAddGroup}
				group={group}
			/>
			<button
				className={'btn btn-icon btn-icon-only btn-outline-primary mb-1'}
				type="button"
				onClick={(evt) => {
					evt.stopPropagation();
					evt.preventDefault();
					setOpenModalAddGroup(true);
				}}
			>
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
					<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
					<path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
				</svg>
			</button>
		</>
	);
}

export default EditGroup;
